import { createContext, useContext, useState } from "react";

// Create Context
const CIBottlerSelectionContext = createContext();

// Context Provider Component
export const CIBottlerSelectionProvider = ({ children }) => {
    const [selectedData, setSelectedData] = useState([]);

    return (
        <CIBottlerSelectionContext.Provider value={{ selectedData, setSelectedData }}>
            {children}
        </CIBottlerSelectionContext.Provider>
    );
};

// Custom Hook for easy access
export const useCIBottlerSelection = () => useContext(CIBottlerSelectionContext);
